// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-timeframeFilter-dateRangeSelector-module__container--CRMnz {
  min-width: 160px;
}

.src-js-components-timeframeFilter-dateRangeSelector-module__heading--pJnND {
  font-size: 11px;
  font-weight: 700;
  color: #A8B0B8;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 10px 0;
}

.src-js-components-timeframeFilter-dateRangeSelector-module__list--eYpSw {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.src-js-components-timeframeFilter-dateRangeSelector-module__item--BoChd {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 6px;
  user-select: none;
  transition: background-color 0.15s ease;
}

.src-js-components-timeframeFilter-dateRangeSelector-module__item--BoChd:hover:not(.src-js-components-timeframeFilter-dateRangeSelector-module__selected--Nrw8Y) {
  background-color: rgba(255, 255, 255, 0.06);
}

/* Selected: orange/coral gradient (Figma) */
.src-js-components-timeframeFilter-dateRangeSelector-module__selected--Nrw8Y {
  background: #FF9600;
  border-radius: 6px;
}

.src-js-components-timeframeFilter-dateRangeSelector-module__selected--Nrw8Y .src-js-components-timeframeFilter-dateRangeSelector-module__label--h7esP {
  color: #ffffff;
  font-weight: 700;
}

.src-js-components-timeframeFilter-dateRangeSelector-module__selected--Nrw8Y .src-js-components-timeframeFilter-dateRangeSelector-module__subtitle--CdbLd {
  color: rgba(255, 255, 255, 0.85);
}

.src-js-components-timeframeFilter-dateRangeSelector-module__label--h7esP {
  font-size: 14px;
  color: rgba(253, 253, 253, 1);
  font-weight: 500;
  line-height: 1.3;
}

.src-js-components-timeframeFilter-dateRangeSelector-module__subtitle--CdbLd {
  font-size: 11px;
  color: #A8B0B8;
  line-height: 1.3;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/timeframeFilter/dateRangeSelector.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA,4CAA4C;AAC5C;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".container {\n  min-width: 160px;\n}\n\n.heading {\n  font-size: 11px;\n  font-weight: 700;\n  color: #A8B0B8;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin: 0 0 10px 0;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 12px;\n  cursor: pointer;\n  border-radius: 6px;\n  user-select: none;\n  transition: background-color 0.15s ease;\n}\n\n.item:hover:not(.selected) {\n  background-color: rgba(255, 255, 255, 0.06);\n}\n\n/* Selected: orange/coral gradient (Figma) */\n.selected {\n  background: #FF9600;\n  border-radius: 6px;\n}\n\n.selected .label {\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.selected .subtitle {\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.label {\n  font-size: 14px;\n  color: rgba(253, 253, 253, 1);\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.subtitle {\n  font-size: 11px;\n  color: #A8B0B8;\n  line-height: 1.3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `src-js-components-timeframeFilter-dateRangeSelector-module__container--CRMnz`,
	"heading": `src-js-components-timeframeFilter-dateRangeSelector-module__heading--pJnND`,
	"list": `src-js-components-timeframeFilter-dateRangeSelector-module__list--eYpSw`,
	"item": `src-js-components-timeframeFilter-dateRangeSelector-module__item--BoChd`,
	"selected": `src-js-components-timeframeFilter-dateRangeSelector-module__selected--Nrw8Y`,
	"label": `src-js-components-timeframeFilter-dateRangeSelector-module__label--h7esP`,
	"subtitle": `src-js-components-timeframeFilter-dateRangeSelector-module__subtitle--CdbLd`
};
export default ___CSS_LOADER_EXPORT___;
